var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",class:{ 'desktop-side': _vm.componentName === 'DesktopSide' },attrs:{"section-data":_vm.adaptedData,"products-data":_vm.productsData}})}
var staticRenderFns = []

export { render, staticRenderFns }